module.exports = __webpack_public_path__ + "img/cprs_c.da5b2ded.webp";